import { LatencyData } from 'core/models/latency';
import { MediaStreamConnector } from './MediaStreamConnector';
import { TimestampDecodingTransformer } from './TimestampDecodingTransformer';
import { TransformingConnector } from './TransformingConnector';

export interface LatencyMeasurable {
    getLatency(): LatencyData | undefined;
}

export function isLatencyMeasurable<T extends object>(connector: T): connector is T & LatencyMeasurable {
    return 'getLatency' in connector;
}

export class TimestampDecodingConnector extends TransformingConnector<TimestampDecodingTransformer> implements LatencyMeasurable {
    private transformer: TimestampDecodingTransformer | undefined;

    constructor(underlying: MediaStreamConnector) {
        super(underlying, receiver => {
            if (receiver.track.kind !== 'video') return undefined;
            const transformer = new TimestampDecodingTransformer();
            this.transformer = transformer;
            return transformer;
        });
    }

    getLatency() {
        return this.transformer?.getLatency();
    }
}
